module.exports = __webpack_public_path__ + "img/asmnticon.a126f6bf.svg";